"use client"
import { useRef, useState } from "react";
import { motion, useInView } from 'framer-motion';
import Marquee from "react-fast-marquee";
function AboutUs({ blok }) {


  const [preview, setPreview] = useState(null);

  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);
  const ref7 = useRef(null);
  const ref8 = useRef(null);
  const ref9 = useRef(null);

  const isInView1 = useInView(ref1, { once: true, margin: "-100px" });
  const isInView2 = useInView(ref2, { once: true, margin: "-100px" });
  const isInView3 = useInView(ref3, { once: true, margin: "-100px" });
  const isInView4 = useInView(ref4, { once: true, margin: "-100px" });
  const isInView5 = useInView(ref5, { once: true, margin: "-100px" });
  const isInView6 = useInView(ref6, { once: true, margin: "-100px" });
  const isInView7 = useInView(ref7, { once: true, margin: "-100px" });
  const isInView8 = useInView(ref8, { once: true, margin: "-100px" });
  const isInView9 = useInView(ref9, { once: true, margin: "-100px" });

  const images = ["/images/cisa.png", "/images/cisco.png", "/images/aws.png", "/images/crest_certified.png", "/images/cve.png", "/images/oscp.png", "/images/pci_auditor.png", "/images/qwasp.png",  "/images/CREST.svg", "/images/Soc2.png", "/images/iso_27001.png", "/images/iso_900.png"];

  return (
    <div className=" w-full">
      <div
        className="bg-asmPageTopBG bg-center bg-cover"
      >
        <div className="max-w-[1920px] m-auto">
          <div className="relative lg:h-full lg:flex flex-col items-center py-8 max-w-[1920px] m-auto">
            {/* Header Section */}
            <div className="font-aileron pt-20 pb-5 lg:pb-32 lg:pt-32 text-center font-bold">
              <h1 className="bg-custom-radial bg-clip-text text-transparent text-[48px] lg:text-[96px] px-2">
                {blok.titleText1}
              </h1>
              <div className="font-lato mt-4 text-[20px] w-[100%] m-auto lg:text-[32px] font-normal px-4">
                {blok.subtitleText1}
              </div>
            </div>
          </div>
          <div className="lg:flex lg:justify-center gap-52 max-w-7xl mx-auto z-20">
            {/* Left Column (Main Image) */}
            <div ref={ref1} className="w-full max-w-md">
              <motion.div
                initial={{ opacity: 0, x: -100 }}
                animate={isInView1 ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="lg:mt-[-10%] lg:w-[554px] lg:h-[440px] h-[290px] w-[290px] flex justify-center items-center m-auto lg:m-0 lg:mb-0">
                <img src={blok.image2.filename} />
              </motion.div>
            </div>

            {/* Right Column (Full Image of Diagram) */}
            <div className="flex-1">
              {/* Description */}
              {/* <h2 className="flex justify-center lg:flex lg:justify-start font-aileron text-[28px] lg:text-[48px] font-semibold bg-custom-radial bg-clip-text text-transparent mb-4 -mt-10">
                {blok.titleText2}
              </h2> */}
              <p className="font-lato text-[16px] lg:text-[18px] lg:mb-2 w-full px-4 m-auto mb-2 lg:m-0 text-center lg:text-start">
                {blok.descriptionText2Para1}
              </p>
              <p className="font-lato text-[16px] lg:text-[18px] lg:mb-2 w-full px-4  m-auto mb-6 lg:m-0 text-center lg:text-start">
                {blok.descriptionText2Para2}
              </p>
              <p className="font-lato text-[16px] lg:text-[18px] lg:mb-2 w-full px-4  m-auto mb-6 lg:m-0 text-center lg:text-start">
                {blok.descriptionText2Para3}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center ">
        <div className="lg:w-[1500px] space-y-10 p-4 lg:p-0">
          {/* Main Content Section */}
          <div className="lg:flex justify-center lg:gap-[50px] lg:w-[1202px] mx-auto z-20 lg:mb-10 bg-white lg:h-[358px] rounded-[40px] py-10 px-4 lg:p-0 lg:mt-20 shadow-2xl shadow-custom-purple">
            {/* Left Column (Main Image) */}
            <div ref={ref2} className="w-full max-w-md">
              <motion.div
                initial={{ opacity: 0, x: -100 }}
                animate={isInView2 ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="lg:mt-16 lg:w-[300px] w-[200px] lg:flex justify-center items-center m-auto mb-10 lg:mb-0">
                <img src={blok.image3.filename} />
              </motion.div>
            </div>

            <div className="lg:flex-1 mt-16">
              <h6 className="bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] font-aileron font-bold lg:mb-10 lg:text-start text-center">
                {blok.titleText3}
              </h6>
              {/* Description */}
              <p className="font-lato text-[16px] lg:text-[18px] lg:mb-6 w-[100%] mb-6 m-auto text-center lg:text-start lg:m-0 lg:pr-20 ">
                {blok.descriptionText3Para1}<br />
                {blok.descriptionText3Para2}
              </p>
            </div>
          </div>
          <div className="flex flex-col-reverse lg:flex-row justify-center lg:gap-[50px] lg:w-[1202px] mx-auto z-20 lg:mb-10 bg-white lg:h-[432px] rounded-[40px] py-10 px-4 lg:p-0 lg:mt-20 shadow-2xl shadow-custom-purple ">
            {/* Left Column (Main Image) */}
            <div className="lg:flex-1 mt-10 lg:ml-20">
              <h6 className="bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] font-aileron font-bold lg:mb-10 lg:text-start text-center">
                {blok.titleText4}
              </h6>
              {/* Description */}
              <p className="font-lato text-[16px] lg:text-[18px] lg:mb-6 w-[100%] mb-6 m-auto text-center lg:text-start lg:m-0">
                {blok.descriptionText4Para1} <br />
                {blok.descriptionText4Para2} <br />
                {blok.descriptionText4Para3}
              </p>
            </div>
            <div ref={ref3} className="w-full max-w-md">
              <div
                initial={{ opacity: 0, x: 100 }}
                animate={isInView3 ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="lg:mt-16 lg:ml-10 lg:w-[300px] w-[200px] lg:flex justify-center items-center m-auto mb-10 lg:mb-0">
                <img src={blok.image4.filename} />
              </div>
            </div>
          </div>
          <div className="lg:flex justify-center lg:gap-[20px] lg:w-[1202px] mx-auto z-20 lg:mb-10 bg-white lg:h-[376px] rounded-[40px] py-10 px-4 lg:p-0 lg:mt-20 shadow-2xl shadow-custom-purple">
            {/* Left Column (Main Image) */}
            <div ref={ref4} className="w-full max-w-md">
              <motion.div
                initial={{ opacity: 0, x: -100 }}
                animate={isInView4 ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="lg:mt-16 lg:w-[300px] w-[200px] lg:flex justify-center items-center m-auto mb-10 lg:mb-0">
                <img src={"/images/drive.svg"} />
              </motion.div>
            </div>

            <div className="lg:flex-1 mt-10">
              <h6 className="bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] font-aileron font-bold lg:mb-6 lg:text-start text-center">
                {blok.titleText5}
              </h6>
              {/* Description */}
              <p className="font-lato text-[16px] lg:text-[18px] lg:mb-6 w-[90%] mb-6 m-auto text-center lg:text-start lg:m-0">
                {blok.descriptionText5Para1} <br />
                {blok.descriptionText5Para2}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className=" lg:h-full lg:flex flex-col items-center py-8  m-auto -mt-20 bg-asmPageBottomBG bg-top bg-cover">
        {/* Header Section */}
        <div className="max-w-[1920px] font-aileron py-20 lg:py-32 text-center font-bold">
          <h1 className="bg-custom-radial bg-clip-text text-transparent text-[38px] lg:text-[80px]">
            {blok.titleText6}
          </h1>
          {blok.subTitleText6 && <div className="font-lato mt-4 text-[20px] w-[100%] m-auto lg:text-[32px] font-normal">
            {blok.subTitleText6}
          </div>}
          <div className="bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] lg:mt-16">
            {blok.title6Text1}
          </div>
          <div className="w-full flex flex-col items-center mt-10">
            <div ref={ref3} className="flex justify-center w-full gap-20 flex-wrap max-w-7xl">
              {blok?.Leadership?.map((item, index) => {
                return <div
                  key={`leadership-${index}`}
                  className="cursor-pointer w-[342px] h-[336px] rounded-[20px] bg-white shadow-2xl shadow-custom-purple mx-auto flex flex-col justify-center items-center"
                  onClick={() => {  setPreview(item) }}

                >
                  <div className="flex justify-center mt-10 w-32 h-32">
                    <img src={item.image.filename} />
                  </div>
                  <p className="font-lato text-[24px] font-medium mt-10 mb-2">
                    {item.title}
                  </p>
                  <p className="font-lato text-[18px] font-medium">{item.ctaText}</p>
                </div>
              })}
            </div>
          </div>
          <div className="bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] lg:mt-16 mt-10">
            {blok.title6Text2}
          </div>
          <div className="w-full flex flex-col items-center mt-10">
            <div ref={ref3} className="flex justify-center w-full gap-20 flex-wrap max-w-7xl">
              {blok?.BoardMembers?.map((item, index) => {
                return <div
                  key={`bordmember-${index}`}
                  onClick={() => setPreview(item)}
                  // initial={{ opacity: 0, x: -100 }}
                  // animate={isInView6 ? { opacity: 1, x: 0 } : {}}
                  // transition={{ duration: 0.4, delay: 0.2 }}
                  className="cursor-pointer w-[342px] h-[336px] rounded-[20px] bg-white shadow-2xl shadow-custom-purple mx-auto flex flex-col justify-center items-center relative z-50">
                  <div className="flex justify-center mt-10 w-32 h-32">
                    <img src={item.image.filename} />
                  </div>
                  <p className="font-lato text-[24px] font-medium mt-10 mb-2">
                    {item.title}
                  </p>
                  <p className="font-lato text-[18px] font-medium">{item.ctaText}</p>
                </div>
              })}
            </div>
          </div>
          <div className="bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] lg:mt-16 mt-10">
            {blok.title6Text3}
          </div>
          <div className="w-full flex flex-col items-center mt-10 mb-40">
            <div ref={ref3} className="flex justify-center w-full gap-20 flex-wrap max-w-7xl">
              {blok?.Advisories?.map((item, index) => {
                return <div
                  key={`advisories-${index}`}
                  onClick={() => setPreview(item)}

                  // initial={{ opacity: 0, x: -100 }}
                  // animate={isInView6 ? { opacity: 1, x: 0 } : {}}
                  // transition={{ duration: 0.4, delay: 0.2 }}
                  className="cursor-pointer w-[342px] h-[336px] rounded-[20px] bg-white shadow-2xl shadow-custom-purple mx-auto flex flex-col justify-center items-center">
                  <div className="flex justify-center mt-10 w-32 h-32">
                    <img src={item.image.filename} />
                  </div>
                  <p className="font-lato text-[24px] font-medium mt-10 mb-2 cursor-pointer">
                    {item.title}
                  </p>
                  <p className="font-lato text-[18px] font-medium">{item.ctaText}</p>
                </div>
              })}
            </div>
          </div>
          <>
            {/* Logos */}


            <div className="overflow-hidden w-full relative pb-5">
              <Marquee className="flex md:gap-14 gap-8 lg:gap-16">
                {[...images].map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt={`carousel-${index}`}
                    className="w-[150px] md:w-[167px] object-contain mx-6"
                  />
                ))}
              </Marquee>
              {/* <motion.div
                className="flex items-center gap-8 md:gap-14 lg:gap-16"
                animate={{ translateX: ['0%', '-50%'] }}
                transition={{ ease: 'linear', duration: 10, repeat: Infinity }}
              >
                {[...images, ...images, ...images, ...images, ...images, ...images, ...images, ...images].map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt={`carousel-${index}`}
                    className="w-[150px] md:w-[167px] object-contain"
                  />
                ))}
              </motion.div> */}
            </div>


          </>
          <div className="bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[80px] mt-20 lg:mt-40 mb-4">
            {blok.titleText8}
          </div>
          <div className="font-lato mt-4 text-[20px] w-[70%] m-auto lg:text-[32px] font-normal  max-w-7xl">
            {blok.subtitleText8}
          </div>
          <div ref={ref9} className="grid grid-cols-1 lg:grid-cols-4 m-auto p-0 justify-items-center items-center lg:w-[100%] mt-20 max-w-7xl gap-20  px-6">
            {blok?.Awards?.map((item, index) => {
              return <div key={index} initial={{ opacity: 0, x: -100 }}
                animate={isInView9 ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="p-6 gap-4 flex flex-col flex-1 h-full bg-white shadow-purple-300 shadow-2xl"
              >
                <img src={item.image.filename} />
                <a href={item.url.cached_url} target="_blank" className="text-[24px] text-[#483889]">{item.title}</a >
              </div>
            })}
          </div>
        </div>
      </div>
      {preview && <div className="fixed w-full h-full flex top-0 justify-center items-center bg-[rgba(0,0,0,0.5)]  z-50 px-2">
        <div className="bg-white w-full p-6 lg:w-1/2 h-[80%] xl:h-auto rounded-2xl lg:flex flex-col lg:flex-row gap-10 justify-between relative flex-wrap overflow-scroll">
          <span className="cursor-pointer absolute top-5 right-5 text-2xl font-aileron text-black " onClick={() => setPreview(null)}>⨯</span>
          <div className="w-full lg:w-auto flex-1 flex justify-center text-center lg:text-left lg:justify-end mt-4 lg:mt-0">
            <img src={preview.image.filename} className="object-contain w-full"></img>
          </div>
          <div className="flex-2 mt-4 lg:mt-0">
            <h1 className="text-3xl text-[#222] ">{preview.title}</h1>
            <h1 className=" text-[#222] text-xl">{preview.ctaText}</h1>
            <hr className="my-4" />
            <p className=" text-[#222] mt-4">{preview.description}</p>
          </div>
        </div>
      </div>
      }
      {/* <Footer blok={blok} /> */}
    </div>
  );
}

export default AboutUs;
